import styled from "styled-components";


export const FooterButtonWrapper = styled.div`
box-shadow: 0px -3px 6px #00000029;
background-color: #fff;
position: fixed;
    bottom: 0;
    width: 100%;
     bottom: 44px;
.d-flex{
    justify-content: space-between;
    padding: 18px 0;
    
    .rightButton{
button{
    background-color:#1B4A83;
    text-transform: capitalize;
    ont-family: 'Noto Sans', sans-serif;
}
    }
    .leftButtons{
        display: flex;
        .leftBtnOne{           
            button{
                border: 1px solid #1B4A83;
                border-radius: 5px;
                color: #1B4A83;
                ont-family: 'Noto Sans', sans-serif;
            }

             button.btnReject{
                border: 1px solid #900916;
                border-radius: 5px;
                background-color: #900916;
                color: white;
                ont-family: 'Noto Sans', sans-serif;
            }
            
        }
        .leftBtnTwo{
            button{
                background-color: #03715B;
                font-family: 'Noto Sans', sans-serif;
            }
          
        }
 button{
    margin: 0 18px;
    text-transform: capitalize;

 }
    }
}


`;